<template>
    <ListCard
        :items="entities"
        @onClick="handleClick"
    />
</template>

<script>
import { ListCard } from '@/components'
import { ENTITIES } from '@/entities/entities'

export default {
    name: 'Entities',
    components: {
        ListCard,
    },
    beforeCreate () {
        this.entities = [
            ...ENTITIES.map(entity => ({ ...entity, icon: 'database' })),
            ...[{
                icon: 'folder',
                label: this.$t('admin.navigation.schema.dicts'),
                to: { name: 'Dicts' },
            },
            {
                icon: 'folder',
                label: this.$t('admin.navigation.schema.transforms'),
                to: { name: 'Transforms' },
            },
            {
                icon: 'folder',
                label: this.$t('admin.navigation.schema.styles'),
                to: { name: 'Styles' },
            }].map(item => ({ ...item, name: item.to.name }))]
    },
    methods: {
        handleClick ({ name }) {
            this.$router.push({ name })
        },
    },
}
</script>
